module.exports = __webpack_public_path__ + "img/NoAccess.384efa57.png";